import { defaultFacilityValues } from "@/consts/defaultFacilityValues";
import { BaseModel } from "@/models/base/BaseModel";

export class FacilitySettingsModel extends BaseModel {
  additionalServicesEnabled: boolean;
  isGroveMenuEnabled: boolean;
  additionalServicesBookingsEnabled: boolean;
  baseUrl: string;
  canFamilyChargeToRoom: boolean;
  canFamilyPayByCard: boolean;
  canFamilySeeNameOfStaffSendingThemPictures: boolean;
  canStaffMessageFamily: boolean;
  familyCanInitiateContact: boolean;
  allowStaffFamilyThreads: boolean;
  familyMessagingAccessLevels: string[];
  isEnableFamilyCareFeedback: boolean;
  countryIso: string;
  familyChatEnabled: boolean;
  scheduledCallsEnabled: boolean;
  digitalSignageLogoUrl: string;
  printableCalendarLogoUrl: string;
  maintenanceEnabled: boolean;
  name: string;
  noticeboardEnabled: boolean;
  orgId: string;
  orgName: string;
  regionId: string;
  regionName: string;
  skin: string;
  skinSettings: any;
  mediaApps: any;
  tvApps: any;
  isOptInLifestylePrograms?: boolean;
  lifestyleProgramsTileOnMyHubEnabled?: boolean;
  isResidentChat: boolean;
  isEnableFamilyNewsletter: boolean;
  familyNewsletterOptions: any;
  mediaEnabled: boolean;
  residentCanTakePhoto: boolean;
  isEnableResidentReligion: boolean;
  canInviteFamilyMembers: boolean;
  residentConsentCheckbox: boolean;
  isEnableResidentEventPictures: boolean;
  isVendorsCanCompleServiceRequests: boolean;
  currencyIso: string;
  languageIso: string = defaultFacilityValues.locale
  dateFormat: string = defaultFacilityValues.dateFormat
  timeFormat: string = defaultFacilityValues.timeFormat
  timeZone: string ;
  isEnableWeeklyLifestyleEventsReport: boolean;
  isEnableCSVImportForResidents: boolean;
  isEnableManuallyAddDeleteResidents: boolean;
  isEnableResidentsCanInviteFamily: boolean;
  isEnableADT: boolean;
  isEnableCareTab: boolean;
  isEnableRoomBooking: boolean;
  isCareSummary: boolean;
  isDailyPlan: boolean;
  isCarePlan: boolean;
  isDailyCare: boolean;
  isCareNotes: boolean;
  isEnabledSharedNotesToMCare: boolean;
  printableCalendarColor: string;
  isHaveDifferentBorderPerWing: boolean;
  lastWingWithBorder: string;
  printableCalendarUrl: string;
  printableCalendarHeaderFont: string;
  printableCalendarHeaderFontSize: string;
  printableCalendarBodyFont: string;
  printableCalendarBodyFontSize: string;
  isDimensionColor: boolean;
  selectedDimensionColorType: string;
  isUseWingsCustomName: boolean;
  wingsCustomNameDescription: string;
  printableCalendarWeekdays: number[];
  printableCalendarCustomImage: string;
  printableCalendarCustomImageSize: object;
  isCanCreateWings: boolean;
  printableCalendarCompactMode: boolean;
  printableCalendarLocationsSize: object;
  printableCalendarHeaderFontColor: string;
  printableCalendarLocationKeysFontSize: string;
  printableCalendarDatesBackgroundColor: string;
  printableCalendarDecorImage: string;
  printableCalendarDecorImageSize: object;
  isUseFacilityCustomName: boolean;
  facilityCustomName: string;
  printableCalendarLogoSize: object;
  isEnabledResidentWingVisibleForOtherResidents: boolean;
  isEnabledResidentInformationVisibleForOtherResidents: boolean;
  isResidentsCanSeeOtherResidentsWingInCommunityTileDirectoryList: boolean;
  isResidentsCanSeeOtherResidentsFullAddressInCommunityTileDirectory: boolean;
  isStaffCanLogInOnBehalfOfResident: boolean;
  printableCalendarConciergeEvents: boolean;
  printableCalendarNoticeEvents: boolean;
  printableCalendarShowEndTime: boolean;
  printableCalendarDatePositionRight: boolean;
  printableCalendarDisplayAMPM: boolean;
  printableCalendarLocationsSizeHeader: object;
  printableCalendarCustomTextBoxSizeHeader: object;
  printableCalendarInputCustomBoxColor: string;
  printableCalendarInputCustomBoxSize: boolean;
  isEnabledStaffDirectory: boolean;
  //staffhub menu items.
  isStaffHubSurveys: boolean;
  isStaffHubContentManagerMediaLibrary: boolean;
  isStaffHubDevicesColumnDigitalSignage: boolean;
  isStaffHubContentManagerGallery: boolean;
  isStaffHubCalendar: boolean;
  isStaffHubMessenger: boolean;
  isStaffHubDocuments: boolean;
  staffHubLogoUrl: string;
  staffHubLogoColor: string;
  orgLogoUrl: string;
  orgLogoColor: string;
  facilityLogoUrl: string;
  facilityLogoColor: string;
  staffDirectory: any;
  printableCalendarCustomLocationKey: string;
  isUseFacilityCustomLocationKeys: boolean;
  printableCalendarTextBoxes: [];
  printableCalendarImages: [];
  printableCalendarBorderColor: boolean;
  printableCalendarDatesColor: string;
  isEnabledCarePlan: boolean;
  isEnabledAddFriendsFromOtherCommunities: boolean;
  isEnabledDocumentsTile: boolean;
  isEnabledKioskButton: boolean;
  isEnabledStaffAPI: boolean;
  isEnabledContactsAPI: boolean;
  isEnabledMyHubFamilyTile: boolean;
  isEnabledFamilyToResidentMessaging: boolean;
  isUsingIntercom: boolean;
  temperatureFormat: string;
  modules: {
    familyEngagementCore: {
      isEnabled: boolean;
      categories: {
        communicationManagement: boolean;
        dailyCare: boolean;
      };
    };
    familyEngagementPlus: {
      isEnabled: boolean;
    };
    digitalSignage: {
      isEnabled: boolean;
      categories: {};
    };
    maintenance: {
      isEnabled: boolean;
      categories: {};
    };
  };
  updatedById: string;
  updatedByType: string;
  typesOfRecordChanged: string[];
  initiatorAccessLevel?: string;
  initiatorName?: string;

  featureLifestyle: boolean;
  featureConcierge: boolean;
  featureDigitalSignage: boolean;
  featureFamilyEngagement: boolean;
  featureMCareDailyCareUpdates: boolean;
  featureMCareContactsProfiles: boolean;
  featureMaintenance: boolean;
  featureNonMCareCustomers: boolean;
  featureOther: boolean;
  
  staffIdleSessionTimeoutSeconds: number;
  residentIdleSessionTimeoutSeconds: number;
  familyIdleSessionTimeoutSeconds: number;

  staffActiveSessionTimeoutSeconds: number;
  residentActiveSessionTimeoutSeconds: number;
  familyActiveSessionTimeoutSeconds: number;

  staffFamilyMessagingEnabled?: boolean;
}
